import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type InsertAppointmentMutationVariables = Types.Exact<{
  appointment: Types.Appointments_Insert_Input;
}>;


export type InsertAppointmentMutation = { __typename?: 'mutation_root', insert_appointments_one?: { __typename?: 'appointments', id: number } | null };


export const InsertAppointmentDocument = gql`
    mutation insertAppointment($appointment: appointments_insert_input!) {
  insert_appointments_one(object: $appointment) {
    id
  }
}
    `;
export type InsertAppointmentMutationFn = Apollo.MutationFunction<InsertAppointmentMutation, InsertAppointmentMutationVariables>;

/**
 * __useInsertAppointmentMutation__
 *
 * To run a mutation, you first call `useInsertAppointmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertAppointmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertAppointmentMutation, { data, loading, error }] = useInsertAppointmentMutation({
 *   variables: {
 *      appointment: // value for 'appointment'
 *   },
 * });
 */
export function useInsertAppointmentMutation(baseOptions?: Apollo.MutationHookOptions<InsertAppointmentMutation, InsertAppointmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertAppointmentMutation, InsertAppointmentMutationVariables>(InsertAppointmentDocument, options);
      }
export type InsertAppointmentMutationHookResult = ReturnType<typeof useInsertAppointmentMutation>;
export type InsertAppointmentMutationResult = Apollo.MutationResult<InsertAppointmentMutation>;
export type InsertAppointmentMutationOptions = Apollo.BaseMutationOptions<InsertAppointmentMutation, InsertAppointmentMutationVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * @source {@link src/features/appointments/queries/insertAppointment.mutation.gql}
 */
export async function insertAppointment(
  variables: InsertAppointmentMutationVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<InsertAppointmentMutation['insert_appointments_one']>
export async function insertAppointment(
  variables: InsertAppointmentMutationVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<InsertAppointmentMutation>
export async function insertAppointment(
  variables: InsertAppointmentMutationVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<InsertAppointmentMutation['insert_appointments_one'] | InsertAppointmentMutation> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).mutate<InsertAppointmentMutation>(
    InsertAppointmentDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.insert_appointments_one
}